import Attrs from '../models/Attrs'
import type { Lottie } from '../models/types'
import replaceStorageURLsFromFirebaseToCloudflare from '../helpers/replaceStorageURLsFromFirebaseToCloudflare'

const CONTROLLER = 'components--lottie'
export default function renderLottie(component: Lottie, attrs: Attrs): string {
  //* For static rendering, lotties wont be included since they are too heavy
  if (attrs.static_render) return '<div></div>'

  const autoplay = component.autoplay === undefined ? true : component.autoplay
  const loop = component.loop === undefined ? true : component.loop
  const controls = component.controls === undefined ? true : component.controls
  const hover = component.hover === undefined ? false : component.hover
  const mode = component.mode || 'normal'
  const aria_label = component.aria_label

  const src = replaceStorageURLsFromFirebaseToCloudflare(component.src) || undefined

  attrs.addController(CONTROLLER).addValueIfExists(CONTROLLER, 'src', src)
  if (autoplay) attrs.addValue(CONTROLLER, 'autoplay', 'true')
  if (loop) attrs.addValue(CONTROLLER, 'loop', 'true')
  if (controls) attrs.addValue(CONTROLLER, 'controls', 'true')
  if (hover) attrs.addValue(CONTROLLER, 'hover', 'true')
  if (mode) attrs.addValue(CONTROLLER, 'mode', mode)

  let lottiePlayerAttrs = new Attrs()
  lottiePlayerAttrs.add('component-id', `id-${component.id}`)
  if (src) lottiePlayerAttrs.add('src', src)
  if (mode) lottiePlayerAttrs.add('mode', mode)
  if (autoplay) lottiePlayerAttrs.add('autoplay', `${autoplay}`)
  if (loop) lottiePlayerAttrs.add('loop', `${loop}`)
  if (controls) lottiePlayerAttrs.add('controls', `${controls}`)
  if (hover) lottiePlayerAttrs.add('hover', `${hover}`)
  if (aria_label) lottiePlayerAttrs.add('aria-label', aria_label.trim().replace(/"/g, '&quot;'))

  return `<div ${attrs.toString()}><lottie-player ${lottiePlayerAttrs.toString()}></lottie-player></div>`
}
